var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00473 7.43335C5.85432 7.43422 5.70522 7.40539 5.56598 7.34852C5.42674 7.29165 5.30009 7.20785 5.1933 7.10192L0.621871 2.53049C0.406667 2.31529 0.285767 2.02341 0.285767 1.71907C0.285767 1.41472 0.406667 1.12284 0.621871 0.907637C0.837076 0.692433 1.12896 0.571533 1.4333 0.571533C1.73764 0.571533 2.02952 0.692433 2.24473 0.907637L6.00473 4.67907L9.76473 0.919066C9.98336 0.731836 10.2646 0.634 10.5522 0.64511C10.8398 0.65622 11.1127 0.775457 11.3162 0.978994C11.5198 1.18253 11.639 1.45538 11.6501 1.74301C11.6612 2.03063 11.5634 2.31186 11.3762 2.53049L6.80473 7.10192C6.59186 7.31306 6.30455 7.43209 6.00473 7.43335Z",
    fill: "#1C75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenDropdown);
export default __webpack_public_path__ + "static/media/openDropdown.9a609bc1b6a5d03f6b53f3b7b90819ab.svg";
export { ForwardRef as ReactComponent };